import React, { useRef, useState } from "react";
import sutherlandLogo from '../assets/img/sutherlandglobal.png';
import esealLogo from '../assets/img/big-logo.png';
import vegIcon from '../assets/img/veg.png';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const Vegrecipe = {
  title: "PANEER - E – LUMINA Recipe",
  ingredients: [
    "Grated Paneer – ½ kg",
    "Chopped Almonds – 50 g",
    "Chopped Cashews – 25 g",
    "Chopped Raisins – 10 g",
    "Chopped Pistachios – 15 g",
    "Cashew Nut Paste – ½ cup",
    "Salt – to taste",
    "Butter – 1½ tablespoons",
    "Fresh Cream – ½ cup",
    "Turmeric Powder – ½ tablespoon",
    "Methi Powder – 1 pinch",
    "Cardamom Powder – 1 pinch",
    "Red Chilli Powder – 1 tablespoon",
    "Kashmiri Chilli Powder – 1 tablespoon",
    "Garam Masala Powder – 1 teaspoon",
    "Ginger-Garlic Paste – 1 tablespoon",
    "Coriander Powder – 1 teaspoon",
    "Cumin Powder – 1 teaspoon",
    "Cooking Oil – 2 tablespoons",
    "Onion, chopped – 1 cup",
    "Green Chilli, chopped – ¼ cup",
    "Coriander Leaves, chopped – 1 tablespoon",
    "Tomato Puree – 1 cup"
  ],
  paneerMixture: [
    "Take a bowl and add the grated paneer, chopped almonds, pistachios, cashews, raisins, salt, chopped green chilli, and cardamom powder. Mix well.",
    "Transfer the mixture to an oven tray and spread it evenly. Bake at 160°C for 15 minutes.",
    "Remove from the oven and allow it to cool to room temperature. Once cooled, cut the baked paneer mixture into small pieces."
  ],
  gravy: [
    "Heat a kadai and add the cooking oil. Once hot, add the chopped onion and sauté for about 5 minutes.",
    "Add the chopped green chilli and ginger-garlic paste. Sauté until the onion turns golden brown.",
    "Add the turmeric powder and mix well. Add the tomato puree and cashew nut paste. Cook for approximately 8 minutes.",
    "Add the red chilli powder, Kashmiri chilli powder, cumin powder, and coriander powder. Mix well and cook for another 5 minutes.",
    "Add the garam masala powder and 1 cup of water. Cover and cook on medium heat for approximately 10 minutes, or until the gravy reaches the desired consistency.",
    "Reduce the heat and add butter, fresh cream, methi powder, and the prepared paneer pieces. Mix gently.",
    "Check and adjust the salt and spices according to taste.",
    "Finally, garnish with chopped fresh coriander and a drizzle of fresh cream."
  ],
  serving: "Tawa Roti, Poori, Flavoured Rice, Jeera Rice"
};

export function VegRecipeUI() {
  const containerRef = useRef();
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);

const handleDownload = async () => {
  setIsDownloading(true);
  setIsDownloaded(false);
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  try {
    const container = containerRef.current;
    if (!container) return;

    const clone = container.cloneNode(true);

    const page = document.createElement('div');
    page.style.position = 'absolute';
    page.style.top = '-9999px';
    page.style.left = '50%';
    page.style.transform = 'translateX(-50%)';
    page.style.background = '#fff';
    page.style.borderRadius = '12px';
    page.style.width = '92vw';
    page.style.maxWidth = '540px';   // slightly narrower to avoid clipping
    page.style.margin = '0';
    page.style.padding = '0.8rem 0.7rem';
    page.style.color = '#212c1d';
    page.style.fontFamily = 'Arial, sans-serif';
    page.style.fontSize = '0.75rem'; // reduce font size overall
    page.style.lineHeight = '1.32';

    // Center header only
    const header = clone.querySelector('.mobile-curry__header').cloneNode(true);
    header.style.width = '100%';
    header.style.textAlign = 'center';
    header.style.marginBottom = '0.4rem';
    const titleRow = header.querySelector('.mobile-curry__title-row');
    if (titleRow) {
      titleRow.style.justifyContent = 'center';
      titleRow.style.display = 'flex';
    }
    page.appendChild(header);

    // Style main sections for small font and minimal margin
    const mainSections = clone.querySelectorAll('main section');
    mainSections.forEach((section) => {
      const clonedSection = section.cloneNode(true);
      clonedSection.style.textAlign = 'left';
      clonedSection.style.fontSize = '0.75rem';
      clonedSection.style.marginBottom = '0.7rem';
      clonedSection.style.padding = '0';

      const lists = clonedSection.querySelectorAll('ul, ol');
      lists.forEach(list => {
        list.style.textAlign = 'left';
        list.style.paddingLeft = '1rem';
        list.style.marginLeft = '0';
        list.style.fontSize = '0.75rem';
      });

      page.appendChild(clonedSection);
    });

    document.body.appendChild(page);

    // Capture the page
    const canvas = await html2canvas(page, { scale: 3, useCORS: true, backgroundColor: null });
    let imgWidth = pdfWidth;
    let imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Scale image if content is taller than PDF page
    if (imgHeight > pdfHeight) {
      imgHeight = pdfHeight;
      imgWidth = (canvas.width * imgHeight) / canvas.height;
    }

    const imgData = canvas.toDataURL('image/png');
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    pdf.save(`${Vegrecipe.title}.pdf`);
    setIsDownloaded(true);

    document.body.removeChild(page);
  } catch (error) {
    console.error('PDF generation error:', error);
  } finally {
    setIsDownloading(false);
  }
};


  return (
    <div className="mobile-curry" ref={containerRef}>
      <header className="mobile-curry__header">
        <h1 className="mobile-curry__event">Lumina 2026 - Chef Special</h1>
        <div className="mobile-curry__title-row">
          <img src={vegIcon} alt="Veg Icon" className="mobile-curry__food-icon" />
          <h2 className="mobile-curry__title">{Vegrecipe.title}</h2>
        </div>
      </header>

      <main className="mobile-curry__card">
        <section>
          <h3>Ingredients</h3>
          <ol>
            {Vegrecipe.ingredients.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ol>
        </section>

        <section className="method-section">
          <h3>Method</h3>
          <div className="method-columns">
            <div className="method-column">
              <h4 className="method-column__title">Prepare the Paneer Mixture</h4>
              <ul>
                {Vegrecipe.paneerMixture.map((step, i) => (
                  <li key={i}>
                    <strong>Step {i + 1}:</strong> {step}
                  </li>
                ))}
              </ul>
            </div>
            <div className="method-divider" />
            <div className="method-column">
              <h4 className="method-column__title">Prepare the Gravy</h4>
              <ul>
                {Vegrecipe.gravy.map((step, i) => (
                  <li key={i}>
                    <strong>Step {i + 1}:</strong> {step}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3>Serving Suggestion</h3>
          <p className="suggestion_description">
            PANEER - E – LUMINA can be served hot with:
          </p>
          <p>{Vegrecipe.serving}</p>
        </section>
      </main>

      <div style={{ textAlign: "center"}}>
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
          .spinner-icon {
            display: inline-block;
            width: 12px;
            height: 12px;
            border: 2px solid currentColor;
            border-top-color: transparent;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
            margin-right: 6px;
            vertical-align: middle;
          }
        `}</style>
        <button
          onClick={handleDownload}
          disabled={isDownloading}
          style={{
            backgroundColor: '#6c5ce7',
            border: 'none',
            borderRadius: '8px',
            color: 'white',
            padding: '8px 16px',
            fontSize: '12px',
            fontWeight: '600',
            cursor: isDownloading ? 'not-allowed' : 'pointer',
            opacity: isDownloading ? 0.8 : 1,
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            transition: 'background-color 0.3s ease',
            userSelect: 'none'
          }}
        >
          {isDownloading ? (
            <>
              <span className="spinner-icon" />
              Downloading...
            </>
          ) : (
            "Download"
          )}
        </button>
      </div>

      <footer className="mobile-curry__footer">
        <img src={sutherlandLogo} alt="Sutherland Logo" className="mobile-curry__footer-logo" />
        <div className="mobile-curry__powered">
          Developed by <img src={esealLogo} alt="eSeal Logo" className="mobile-curry__powered-logo" /> eSeal Team
        </div>
      </footer>
    </div>
  );
}
